module.exports = __webpack_public_path__ + "img/right-info-close-light01.9c9cc2e5.png";